
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/analytics';
import { trackFunnelEvent } from '@/utils/funnelTracker';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView();
    trackFunnelEvent('page_view', pathname);
  }, [pathname]);

  return null;
};
